import React from "react";
import { Image } from "@chakra-ui/react";

export const PineappleCakeSection = React.memo(() => {
  const openURL = React.useCallback(() => {
    window.open(
      "https://promo.hungfooktong.com/hftcms/index.php?option=com_content&view=article&id=1048"
    );
  }, []);

  return (
    <Image
      cursor="pointer"
      onClick={openURL}
      src={require("assets/pineapple-cake.png")}
    />
  );
});
